import * as d3 from 'd3'
import _ from 'lodash'

export const no_format = (n) => n

export const default_number_format = _.memoize((n, p=3) => {
  if(n === 0) return '0'
  const abs_n = Math.abs(n)
  let sign = n > 0 ? '' : '-'

  if(abs_n > 0 && abs_n < 0.01) return d3.format(`${sign}.${Math.max(p-2, 2)}~e`)(n)
  if(abs_n >= 1000 && abs_n < 1000000) return d3.format(`${sign}.${p}~s`)(n)
  if(abs_n >= 1000000 && abs_n < 1000000000) return d3.format(`${sign}.${p}~s`)(n)
  if(abs_n >= 10000000) return d3.format(`${sign}.${p}~e`)(n)
  return d3.format(`${sign}.${p}~f`)(n)
})

export const default_time_format = d3.timeFormat('%x')
